var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShoppingCartMenu = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFD5B5",
  fillRule: "evenodd",
  d: "m19.527 10.92-.75 7.38c-.15 1.53-.79 2.7-2.98 2.7h-7.57c-2.24 0-2.83-1.17-2.99-2.7l-.76-7.37c.16.05.33.07.51.07h14c.19 0 .37-.03.54-.08",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FF7A14",
  d: "M19 7h-1.723l-2.614-4.384a.75.75 0 0 0-1.289.767l2.156 3.616H8.479l2.181-3.612a.75.75 0 1 0-1.283-.776L6.728 6.999H5a2 2 0 0 0 0 4h14A2 2 0 0 0 19 7M10.016 18.25a.75.75 0 0 1-.75-.75v-3a.75.75 0 0 1 1.5 0v3a.75.75 0 0 1-.75.75m4.75-.75v-3a.75.75 0 0 0-1.5 0v3a.75.75 0 0 0 1.5 0"
})));
export default SvgShoppingCartMenu;